export default __webpack_public_path__ + "static/media/favicon.abb4dc76.svg";